export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '관리감독자'}, {name: '관리감독자 소속명'}, {name: '작성 부서명'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name // 사업장명
      case 1:
        return func.getContent(value).inputC_1 // 관리감독자
      case 2:
        return func.getContent(value).inputC_2  // 관리감독자 소속명
      case 3:
        return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 부서명
      case 4:
        return func.getContent(value).stdInfo.writer_name // 작성자
      case 5:
        return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (ignore) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return {searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword}
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '사업장명':
      returnData.push('content$body.stdInfo.field_name*%[:default_skw]%');
      break
    case '관리감독자':
      returnData.push('content$body.inputC_1*%[:default_skw]%');
      break
    case '관리감독자 소속명':
      returnData.push('content$body.inputC_2*%[:default_skw]%');
      break
    case '작성 부서명':
      'content$body.stdInfo.section*%[:default_skw]%' ? returnData.push('content$body.stdInfo.section*%[:default_skw]%') : returnData.push('content$body.stdInfo.com_name*%[:default_skw]%');
      break
    case '작성자':
      returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%');
      break
    }
    return returnData
  },
}
